import { Component } from 'react';
import { inject } from 'mobx-react';

@inject('$lookups')
class Lookup extends Component {
  static cache = new Map();

  state = {
    label: ''
  };

  componentDidMount() {
    this.doLookup();
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (value !== prevProps.value) {
      this.doLookup();
    }
  }

  doLookup() {
    const { $lookups, value, lookup } = this.props;

    if (!value) {
      this.setState({ label: value });
      return;
    }

    const cacheKey = `${lookup}:${value}`;
    const cachedValue = Lookup.cache.get(cacheKey);
    if (cachedValue) {
      this.setState({ label: cachedValue });
      return;
    }

    const lookupFn =
      $lookups[lookup] ||
      $lookups.autoCompleteDimensionHandlers[lookup] ||
      $lookups.autoCompleteFilterQueryHandlers[lookup];

    if (!lookupFn) {
      this.setState({ label: value });
      Lookup.cache.set(cacheKey, value);
      return;
    }

    lookupFn(value, { debounce: false }).then((options) => {
      /* eslint-disable-next-line eqeqeq */
      const option = options.find((o) => o.value == value);

      const label = option ? option.label : value;

      Lookup.cache.set(cacheKey, label);

      this.setState({ label });
    });
  }

  render() {
    const { value } = this.props;
    const { label } = this.state;

    return label || value || null;
  }
}

export default Lookup;
